<script>
  import { default as QrCode } from "qrious";
  import { createEventDispatcher } from "svelte";

  export let errorCorrection = "L";
  export let value;
  export let background = "#fff";
  export let color = "#000";
  export let size = "200";
  export let padding = 0;
  export let qrState = "clear";

  let qrCode;
  let image;

  const dispatch = createEventDispatcher();

  $: setValue(value);

  function setValue(value) {
    if (!!value) {
      const qrCode = new QrCode();
      qrCode.set({
        background,
        foreground: color,
        level: errorCorrection,
        padding,
        size,
        value,
      });
      image = qrCode.toDataURL("image/jpeg");
    }
  }
</script>

{#if !!value}
  <img
    on:keydown
    src={image}
    class={qrState}
    alt={value}
    on:click
  />
{/if}

<style>
  .blur {
    filter: blur(8px);
    -webkit-filter: blur(8px);
  }
</style>
